module.exports = __webpack_public_path__ + "static/media/pranjil.681a1fd4.jfif";